import Amount from '@/types/Amount';

export default class Shipment {
	public shipmentId: string;
	public shippingId: string;
	public shipmentMethod: Map<string, string>;
	public trackingCode: string;
	public trackingUrl: string;
	public deliveryCompany: string;
    public price: Amount;
    public discount: Amount;
}
